
export default {
  name: "Settings",
  data() {
    return {
      showFilterPopover: false,
      showFilterPopover2: false,
      showDeletePopup: false,
      deleteIndex: "",
      filterList: [],
      filterList2: [],
      selectFilter: "",
      selectFilter2: "",
      selectVoltage: [],
      activeSetting: "mySettings", //recommended or mySettings
      recommendedList: [],
      mySettingList: [],
      pageNum_tab1: 1,

      total_tab1: 0,
      loading_tab1: false,
      load_error_tab1: false,
      finished_tab1: false,

      pageNum_tab2: 1,
      total_ta2: 0,
      loading_tab2: false,
      load_error_tab2: false,
      finished_tab2: false
    };
  },
  created() {
    if (this.$route.params.selectVoltage) {
      this.selectVoltage = this.$route.params.selectVoltage;
      window.localStorage.setItem(
        "selectVoltage",
        JSON.stringify(this.selectVoltage)
      );
    } else {
      this.selectVoltage = JSON.parse(
        window.localStorage.getItem("selectVoltage")
      );
      if (!this.selectVoltage) this.selectVoltage = [];
    }
  },
  mounted() {
    let activeSetting = this.$route.params.activeSetting;
    if (activeSetting) this.activeSetting = activeSetting;
    this.getfilterByRecommend();
    this.getMySettingsList();
    this.getRecommendedList();

    //挂载成功后给pop事件绑定一个方法
    // 如果支持 popstate （一般移动端都支持）
    if (window.history && window.history.pushState) {
      // 往历史记录里面添加一条新的当前页面的url
      history.pushState(null, null, document.URL);
      // 给 popstate 绑定一个方法用来监听页面返回
      window.addEventListener("popstate", this.onClickHeaderReturn, false); //false阻止默认事件
    }
  },
  destroyed() {
    window.removeEventListener("popstate", this.onClickHeaderReturn, false); //false阻止默认事件
  },
  watch: {},
  computed: {},
  methods: {
    onClickSave() {
      let idList = [];
      idList = this.selectVoltage.map((item) => {
        return item.id;
      });
      this.$api.writer
        .saveUseSettings({
          id: idList
        })
        .then((res) => {
          if (res.code == 200) {
            this.$toast({
              type: "success",
              duration: "1000",
              forbidClick: "true",
              position: "middle",
              message: res.message
            });
            setTimeout(() => {
              this.$router.replace({
                name: "Home",
                params: {
                  refresh: true
                }
              });
            }, 1000);
          } else {
            this.$toast({
              type: "fail",
              duration: "2000",
              position: "middle",
              message: res.message
            });
          }
        })
        .catch((error) => {
        });
    },
    async onLoadTab1() {
      this.pageNum_tab1++;
      await this.getRecommendedList();
      this.loading_tab1 = false;

      if (this.recommendedList.length >= this.total_tab1) {
        this.finished_tab1 = true;
      }
    },
    async onLoadTab2() {
      this.pageNum_tab2++;
      await this.getMySettingsList();
      this.loading_tab2 = false;

      if (this.mySettingList.length >= this.total_tab2) {
        this.finished_tab2 = true;
      }
    },
    async getRecommendedList() {
      await this.$api.writer
        .selectRecommendSettingsDetails({
          pageNum: this.pageNum_tab1,
          pageSize: 10,
          flavorId: this.selectFilter
        })
        .then((res) => {
          if (res.code == 200) {
            res.data.forEach((element) => {
              element.checked = false;
              this.selectVoltage.forEach((item) => {
                if (element.id == item.id) {
                  element.checked = true;
                  return;
                }
              });
            });
            this.recommendedList = this.recommendedList.concat(res.data);
            this.total_tab1 = res.total;
            if (res.total <= 10) {
              this.finished_tab1 = true;
            }
          } else {
            this.load_error_tab1 = true;
          }
        })
        .catch((error) => {
          this.load_error_tab1 = true;
          this.recommendedList = [];
          this.total_tab1 = 0;
        });
    },
    async getMySettingsList() {
      await this.$api.writer
        .selectMySettingsDetails({
          pageNum: this.pageNum_tab2,
          pageSize: 10,
          flavorId: this.selectFilter2
        })
        .then((res) => {
          if (res.code == 200) {
            res.data.forEach((element) => {
              element.checked = element.useStatus == 0 ? false : true;
              this.selectVoltage.forEach((item) => {
                if (element.id == item.id) {
                  element.checked = true;
                  return;
                }
              });
            });
            this.mySettingList = this.mySettingList.concat(res.data);
            this.total_tab2 = res.total;
            if (res.total <= 10) {
              this.finished_tab2 = true;
            }
          } else {
            this.load_error_tab2 = true;
          }
        })
        .catch((error) => {
          this.load_error_tab2 = true;
          this.mySettingList = [];
          this.total_tab2 = 0;
        });
    },
    getfilterByRecommend() {
      this.$api.writer
        .selectFlavorByRecommend({
          isRecommend: 0
        })
        .then((res) => {
          if (res.code == 200) {
            res.data.forEach((element) => {
              element.text = element.modeName;
            });
            this.filterList = res.data;
          } else {
            this.filterList = [];
          }
        });
      this.$api.writer
        .selectFlavorByRecommend({
          isRecommend: 1
        })
        .then((res) => {
          if (res.code == 200) {
            res.data.forEach((element) => {
              element.text = element.modeName;
            });
            this.filterList2 = res.data;
          } else {
            this.filterList2 = [];
          }
        });
    },
    onClickHeaderReturn() {
      this.$router.replace("Home");
    },
    onClickDeleteMyVoltage(index) {
      if (this.selectVoltage.length == 1) {
        this.$toast({
          type: "fail",
          duration: "3000",
          position: "middle",
          message: "At least one voltage curve should be selected."
        });
        return;
      }
      let modeId = this.selectVoltage[index].id;
      if (this.recommendedList.findIndex((item) => item.id == modeId) != -1) {
        this.recommendedList[
          this.recommendedList.findIndex((item) => item.id == modeId)
          ].checked = false;
      }
      if (this.mySettingList.findIndex((item) => item.id == modeId) != -1) {
        this.mySettingList[
          this.mySettingList.findIndex((item) => item.id == modeId)
          ].checked = false;
      }
      this.selectVoltage.splice(index, 1);
    },
    onClickApply(index, checked, mode) {
      if (this.selectVoltage.length >= 5 && !checked) {
        this.$toast({
          type: "fail",
          duration: "3000",
          position: "middle",
          message: "Only five voltage curves can be selected at most."
        });
        return;
      }
      if (this.selectVoltage.length == 1 && checked) {
        this.$toast({
          type: "fail",
          duration: "3000",
          position: "middle",
          message: "At least one voltage curve should be selected."
        });
        return;
      }
      if (mode == "recommendedList") {
        let modeId = this.recommendedList[index].id;
        this.recommendedList[index].checked =
          !this.recommendedList[index].checked;
        if (this.recommendedList[index].checked) {
          if (!this.selectVoltage.some((item) => item.id == modeId)) {
            this.selectVoltage.push(this.recommendedList[index]);
          }
        } else {
          let cancelIndex = this.selectVoltage.findIndex(
            (item) => item.id == modeId
          );
          this.selectVoltage.splice(cancelIndex, 1);
        }
      } else if (mode == "mySettingsList") {
        let modeId = this.mySettingList[index].id;
        this.mySettingList[index].checked = !this.mySettingList[index].checked;
        if (this.mySettingList[index].checked) {
          if (!this.selectVoltage.some((item) => item.id == modeId)) {
            this.selectVoltage.push(this.mySettingList[index]);
          }
        } else {
          let cancelIndex = this.selectVoltage.findIndex(
            (item) => item.id == modeId
          );
          this.selectVoltage.splice(cancelIndex, 1);
        }
      }
    },
    onClickCreateMySetting() {
      this.$router.replace("CreateVoltage");
    },
    getContainer() {
      // 返回一个特定的 DOM 节点，作为挂载的父节点
      return document.querySelector(".recommended-header-filter");
    },
    getContainer2() {
      // 返回一个特定的 DOM 节点，作为挂载的父节点
      return document.querySelector(".my-setting-header-filter");
    },
    onSelectFilter(item, index) {
      if (this.activeSetting == "recommended" && item) {
        if (item.id == this.selectFilter) {
          item.className = "";
          this.selectFilter = "";
        } else {
          this.filterList.forEach((element) => {
            element.className = "";
          });
          item.className = "active-filter";
          this.selectFilter = item.id;
        }

        this.pageNum_tab1 = 1;
        this.finished_tab1 = false;
        this.total_tab1 = 0;
        this.recommendedList = [];
        this.getRecommendedList();
      } else if (this.activeSetting == "mySettings" && item) {
        if (item.id == this.selectFilter2) {
          item.className = "";
          this.selectFilter2 = "";
        } else {
          this.filterList2.forEach((element) => {
            element.className = "";
          });
          item.className = "active-filter";
          this.selectFilter2 = item.id;
        }

        this.pageNum_tab2 = 1;
        this.finished_tab2 = false;
        this.total_tab2 = 0;
        this.mySettingList = [];
        this.getMySettingsList();
      }
    },
    onClickDeleteSure() {
      if (!this.$utils.isNullAndEmpty(this.deleteIndex)) {
        this.$api.writer
          .deleteCurveById({
            id: this.mySettingList[this.deleteIndex].id
          })
          .then((res) => {
            console.log(res);
            if (res.code === 200) {
              let voltageIndex = this.selectVoltage.findIndex(
                (item) => item.id === this.mySettingList[this.deleteIndex].id
              );
              if (voltageIndex != -1)
                this.selectVoltage.splice(voltageIndex, 1);

              this.mySettingList.splice(this.deleteIndex, 1);
              this.showDeletePopup = false;
              setTimeout(() => {
                this.$toast({
                  type: "success",
                  duration: "1500",
                  forbidClick: "true",
                  position: "middle",
                  message: res.message
                });
              }, 200);
            } else {
              this.showDeletePopup = false;
              setTimeout(() => {
                this.$toast({
                  type: "fail",
                  duration: "1500",
                  forbidClick: "true",
                  position: "middle",
                  message: res.message
                });
              }, 200);
            }
          })
          .catch((error) => {
            this.showDeletePopup = false;
            setTimeout(() => {
              this.$toast({
                type: "fail",
                duration: "1500",
                forbidClick: "true",
                position: "middle",
                message: error.message
              });
            }, 200);
          });
      }
    },
    onClickEditVoltage(id) {
      this.$router.replace({
        name: "CreateVoltage",
        params: {
          editId: id,
          model: "edit"
        }
      });
    }
  }
};
